import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface CompareItem {
  id: number;
  reference: string;
  name: string;
  slug?: string;
  price: number;
  quantity?: number;
  allow_backorder?: boolean;
  manufacturer_name?: string;
  category_name?: string;
  image?: string | null;
}

interface CompareStore {
  items: CompareItem[];
  add: (item: CompareItem) => boolean; // returns false if max reached
  remove: (id: number) => void;
  toggle: (item: CompareItem) => boolean;
  clear: () => void;
  has: (id: number) => boolean;
}

const MAX_ITEMS = 4;

export const useCompareStore = create<CompareStore>()(
  persist(
    (set, get) => ({
      items: [],

      add: (item) => {
        const state = get();
        if (state.items.some((i) => i.id === item.id)) return true;
        if (state.items.length >= MAX_ITEMS) return false;
        set({ items: [...state.items, item] });
        return true;
      },

      remove: (id) => set((state) => ({ items: state.items.filter((i) => i.id !== id) })),

      toggle: (item) => {
        const state = get();
        if (state.items.some((i) => i.id === item.id)) {
          set({ items: state.items.filter((i) => i.id !== item.id) });
          return false;
        }
        if (state.items.length >= MAX_ITEMS) return false;
        set({ items: [...state.items, item] });
        return true;
      },

      clear: () => set({ items: [] }),

      has: (id) => get().items.some((i) => i.id === id),
    }),
    { name: 'autofrance-compare' }
  )
);
